import React from "react";
import { Link } from "react-router-dom";
import { SearchIcon } from "lucide-react";
import { SectionLabel } from "../SectionLabel";
const sampleResults = [{
  type: "State guide",
  title: "California — Final pay",
  updated: "Updated Oct 14, 2026"
}, {
  type: "Issue brief",
  title: "Remote employees and multi-state withholding",
  updated: "Updated Aug 4, 2026"
}, {
  type: "Playbook",
  title: "Payroll without its owner: the first 72 hours",
  updated: "Updated Oct 2, 2026"
}];
export function IntelligenceTeaser() {
  return <section aria-labelledby="intelligence-teaser" className="shell py-24 md:py-32" data-id="element-470" data-mp="104ze1bx00mla">
      <div className="grid grid-cols-12 items-center gap-x-6 gap-y-14" data-id="element-471" data-mp="14ybswubvlf0u">
        <div className="col-span-12 lg:col-span-5" data-id="element-472" data-mp="18zds5b5slr2t">
          <SectionLabel data-id="element-473" data-mp="18y2ln3kyq580">Constant Intelligence</SectionLabel>
          <h2 id="intelligence-teaser" className="mt-6 font-display text-[clamp(2.25rem,4.4vw,3.75rem)] leading-[1.05] text-navy" data-id="element-474" data-mp="1dyqezvwnyy5e">
            The knowledge behind our work, built to be searched.
          </h2>
          <p className="mt-6 max-w-md leading-relaxed text-charcoal/75" data-id="element-475" data-mp="2dffu2fr1u1ei">
            State and international payroll guides, system guides, playbooks, and issue briefs — maintained by the people
            who use them on live engagements.
          </p>
          <Link to="/intelligence" className="link-rule mt-10" data-id="element-476" data-mp="1zeli5n4slib3">
            Explore Constant Intelligence
          </Link>
        </div>

        <Link to="/intelligence?q=California+final+pay" aria-label="Try a search in Constant Intelligence: California final pay" className="group col-span-12 block border border-navy bg-ivory lg:col-span-6 lg:col-start-7" data-id="element-477" data-mp="2w3t24qprjjcw">
          <div className="flex items-center gap-4 border-b-2 border-navy px-6 py-5" data-id="element-478" data-mp="2idh98plctgkp">
            <SearchIcon aria-hidden strokeWidth={1.25} className="h-5 w-5 shrink-0 text-navy" data-id="element-479" data-mp="2ibmy22zvx2tt" />
            <span className="font-display text-2xl text-navy" data-id="element-480" data-mp="3fuodxyrh1vaz">California final pay</span>
            <span aria-hidden className="ml-1 h-6 w-px animate-pulse bg-oxblood motion-reduce:animate-none" data-id="element-481" data-mp="3b020lq1txso9" />
          </div>
          <ul data-id="element-482" data-mp="2s2o25amqhl4">
            {sampleResults.map((r, i) => <li key={r.title} className={`border-b border-stone px-6 py-4 last:border-b-0 ${i === 0 ? "border-l-2 border-l-oxblood bg-stone/30" : ""}`} data-id="element-483" data-mp="2rki2gy60p00" data-mpi={i}>
                <p className="eyebrow text-[10px] text-oxblood" data-id="element-484" data-mp="3p5u96xthcb4h">{r.type}</p>
                <p className="mt-2 font-display text-xl text-navy transition-colors duration-150 group-hover:text-oxblood" data-id="element-485" data-mp="3b74axeuxc5ej">
                  {r.title}
                </p>
                <p className="mt-1 text-[11px] text-charcoal/55" data-id="element-486" data-mp="327pl8hmkzyv3">{r.updated}</p>
              </li>)}
          </ul>
        </Link>
      </div>
    </section>;
}